module.exports = __webpack_public_path__ + "img/home.9bb211d8.png";